// extracted by mini-css-extract-plugin
module.exports = {"buttonStyle":"role_buttonStyle__3GAnu","buttonRight":"role_buttonRight__21TTh"};